module.exports = __webpack_public_path__ + "static/favicon-3809d4489b7f24864d1f5534d10f6a7a.ico";